var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-menu"},[_c('MenuBaseComponent',{attrs:{"menu-properties":_vm.menuProperties}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }